import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MbpButtonComponent } from '@components/form';
import { ConfirmationService } from '@services/confirmation';
import { MbpModalComponent } from '../mbp-modal/mbp-modal.component';

@Component({
  selector: 'mbp-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  imports: [TranslateModule, MbpModalComponent, MbpButtonComponent]
})
export class ConfirmationModalComponent {
  private readonly confirmationService = inject(ConfirmationService);

  protected options = this.confirmationService.activeOptions;

  protected onCancel(): void {
    this.confirmationService.complete('cancel');
  }

  protected onAlt(): void {
    this.confirmationService.complete('alt');
  }

  protected onConfirm(): void {
    this.confirmationService.complete('confirm');
  }
}
